var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-input", {
        ref: "periodPicker",
        attrs: {
          label: _vm.field.name,
          placeholder: "00.00.0000 - 00.00.0000",
          type: "period-without-fixed-intervals",
          icon: "calendar",
          "required-mark": _vm.field.required,
          "icon-right": true,
          clearable: true,
          flip: true,
          required: _vm.error,
          "required-message": _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }